export default {
    EXTENSION_ID: 188,
    AUTO_COMPLETE_TYPE_KEYS: [6],
    MULTISELECT_TYPE_KEYS: [16]
}
